import { createActions } from 'redux-actions';

export const { updateNetwork, setNetworksReady, setActiveNetwork, setNetworks } = createActions(
  'UPDATE_NETWORK',
  'SET_NETWORKS_READY',
  'SET_ACTIVE_NETWORK',
  'SET_NETWORKS',
);
